import crew01 from '../assets/crew/crew-01.svg';
import bit01 from '../assets/crew/crew-01-bit.svg';
import crew02 from '../assets/crew/crew-02.svg';
import bit02 from '../assets/crew/crew-02-bit.svg';
import crew03 from '../assets/crew/crew-03.svg';
import bit03 from '../assets/crew/crew-03-bit.svg';
import crew04 from '../assets/crew/crew-04.svg';
import bit04 from '../assets/crew/crew-04-bit.svg';
import crew05 from '../assets/crew/crew-05.svg';
import bit05 from '../assets/crew/crew-05-bit.svg';
import crew06 from '../assets/crew/crew-06.svg';
import bit06 from '../assets/crew/crew-06-bit.svg';
import crew07 from '../assets/crew/crew-07.svg';
import bit07 from '../assets/crew/crew-07-bit.svg';
import crew08 from '../assets/crew/crew-08.svg';
import bit08 from '../assets/crew/crew-08-bit.svg';
import crew09 from '../assets/crew/crew-09.svg';
import bit09 from '../assets/crew/crew-09-bit.svg';
import crew10 from '../assets/crew/crew-10.svg';
import bit10 from '../assets/crew/crew-10-bit.svg';

// The league crew from the login screen, left to right as in the group photo.
// The intro shows each guy doing his bit (bit) with his line (says); the lineup uses art.
export const CREW = [
  { art: crew01, bit: bit01, name: 'John', says: 'Go Colts!' },
  { art: crew02, bit: bit02, name: 'Evan', says: '010101' },
  { art: crew03, bit: bit03, name: 'Bush', says: 'My eye is bleeding!' },
  { art: crew04, bit: bit04, name: 'Pat', says: 'Science rules!' },
  { art: crew05, bit: bit05, name: 'Michael', says: "I guess I'll take him for $7!" },
  { art: crew06, bit: bit06, name: 'Chrome', says: 'Money is no issue.' },
  { art: crew07, bit: bit07, name: 'Connor', says: "Wanna take a ride in my '57?" },
  { art: crew08, bit: bit08, name: 'Ben', says: 'Ptooey!' },
  { art: crew09, bit: bit09, name: 'Weltz', says: 'OIP!' },
  { art: crew10, bit: bit10, name: 'Logan', says: "I'm from Denver, bro." },
];
